require('./contractEasyLoanTypeCStep1.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { AmountInput } = require('commonsComponents/amountInput');

// @components
const ContractLoanSliders = require('../../contractLoanSliders/contractLoanSliders');
const ContractEasyLoanStepOneWaffer = require('../../contractEasyLoan/contractEasyLoanStep1Waffer/contractEasyLoanStep1Waffer');
const ContractLoanDueInformation = require('../../contractLoanDueInformation/contractLoanDueInformation');

const {
    PURPOSE_BUY_VEHICLE_TEXT,
    PURPOSE_FIX_HOUSE_TEXT,
    PURPOSE_HOME_ELEMENTS_TEXT,
    PURPOSE_STUDIES_TEXT,
    PURPOSE_HEALTH_TEXT,
    PURPOSE_TRAVEL_TEXT,
    PURPOSE_OTHER_TEXT
} = require('../../../../loansConstants/index').contractEasyLoanTypeC;

const {
    OUTCOME,
    INCOME,
    EXPENSES,
    RENTAL
} = require('../../../../loansConstants/index').easyLoanTypeCLaborFields;

const {
    DEFAULT_LOANS_DECIMALS_LENGTH,
    MAX_LENGTH_NUMBER_INPUT,
    LOANS_MORTGAGES_EASY_LOAN_TYPE_C,
} = require('../../../../loansConstants/index');
const { EURO_SYMBOL, NUMBER_WITH_DECIMALS_REGEX, EMPTY_REGEX } = require('constants/index');
const { 
    recordEasyLoanCPurposeFocus, 
    recordEasyLoanCPurposeBlur, 
    recordPurposeSelectChange, 
    recordEasyLoanCMonthlyIncome, 
    recordEasyLoanCMonthlyExpenses, 
    recordEasyLoanCRentalExpenses,
    recordEasyLoanCEmploymentStatusFocus,
    recordEasyLoanCEmploymentStatusBlur,
    recordEasyLoanCAuthorizationCheckbox,
    recordEasyLoanCINEClick,
    recordEasyLoanCEmploymentStatus,
    recordEasyLoanCApprovedEmploymentLevel,
    recordEasyLoanCApprovedEmploymentLevelOpen,
    recordEasyLoanCApprovedEmploymentLevelClose,
    recordEasyLoanTypeCContract,
    recordEasyLoanTypeCContractOpen,
    recordEasyLoanTypeCContractClose,
} = require( '../analytics/contractEasyLoanTypeC.tracking' );


//@core
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
//@utilities
const { getFormattedString } = require('utilities/currencyHelper');

class ContractEasyLoanTypeCStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { agreeCheckModal: false };
        this.handleAgreeCheckModal = this.handleAgreeCheckModal.bind(this);
        this.handlePurposeSelectChange = this.handlePurposeSelectChange.bind(this);
        this.handlePreContractInformationDownload = this.handlePreContractInformationDownload.bind(this);
        this.onIncomeChange = this.onIncomeChange.bind(this);
        this.onExpensesChange = this.onExpensesChange.bind(this);
        this.onRentalChange = this.onRentalChange.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleJobTypeChange = this.handleJobTypeChange.bind(this);
        this.handleEmploymentLevelChange = this.handleEmploymentLevelChange.bind(this);
        this.handleContractTypeChange = this.handleContractTypeChange.bind(this);
    }


    getPurposeTranslation(constant) {

        const purposeTranslationsSubkey = {
            PURPOSE_BUY_VEHICLE: PURPOSE_BUY_VEHICLE_TEXT,
            PURPOSE_FIX_HOUSE: PURPOSE_FIX_HOUSE_TEXT,
            PURPOSE_HOME_ELEMENTS: PURPOSE_HOME_ELEMENTS_TEXT,
            PURPOSE_STUDIES: PURPOSE_STUDIES_TEXT,
            PURPOSE_HEALTH: PURPOSE_HEALTH_TEXT,
            PURPOSE_TRAVEL: PURPOSE_TRAVEL_TEXT,
            PURPOSE_OTHER: PURPOSE_OTHER_TEXT
        };

        const translationSubkey = purposeTranslationsSubkey[constant];
        const wholeTransKey = 'contractEasyLoanStepOne-' + translationSubkey;

        return formatText(wholeTransKey);
    }

    // *** Section builers ***

    buildHeader() {
        const immContractEasyLoan = this.props.immContractEasyLoan;

        const maxAmountToHireObj = {
            amount: immContractEasyLoan.get('maxAmount'),
            decimalsLength: 0,
            currency: immContractEasyLoan.get('currency')
        };

        const maxAmountToHire = getFormattedString(maxAmountToHireObj);
        const maximumAvailableTerms = immContractEasyLoan.get('maxTerm');

        const injectedStrings = [maxAmountToHire, maximumAvailableTerms];
        return (
            <header className="contract-easy-loan-type-c-step1__header">
                <div className="contract-easy-loan-type-c-step1__title">
                    <FormattedText value="contractEasyLoanTypeCStepOne-title" />
                </div>
                <div className="contract-easy-loan-type-c-step1__informative-text">
                    <FormattedText value="contractEasyLoanTypeCStepOne-messageOne" />

                </div>
                <div className="contract-easy-loan-type-c-step1__secondary-message">
                    <FormattedText value="contractEasyLoanTypeCStepOne-messageTwo" injectedStrings={injectedStrings} />
                </div>
            </header>
        );
    }

    buildPurposeSelect() {
        const { immContractEasyLoan } = this.props;
        const selectedPurpose = immContractEasyLoan.get('selectedPurpose');
        const newPurposesList = immContractEasyLoan.get('newPurposesList');
        const errorState = this.props.immContractEasyLoan.get('showPurposeError');
        const errorMessage = formatText('contractEasyLoanStepOne-purposeError');
        //(nicolas.olmos): selected value is only used to generate PDF.
        return (
            <div className="contract-easy-loan-type-c-step1__purpose-select-view">
                <div className="contract-easy-loan-type-c-step1__purpose-select-title">
                    <FormattedText value="contractEasyLoanStepOne-purpose" />
                </div>
                <OKSelect
                    errorState={errorState}
                    errorMessage={errorMessage}
                    options={newPurposesList.toJS()}
                    value={selectedPurpose}
                    searchable={false}
                    onChange={this.handlePurposeSelectChange}
                    onFocusFunc={recordEasyLoanCPurposeFocus}
                    onBlur={recordEasyLoanCPurposeBlur}
                />
            </div>
        );
    }

    buildSliderSection() {
        const { immContractEasyLoan, setLoanTerm, setLoanAmount,
            getInstallment, requestMinInstallmentQuantity, showTooltip } = this.props;
        const maxAmountError = immContractEasyLoan.get('maxAmountError');

        return (
            <ContractLoanSliders
                amountMaxInstallment
                showSectionTitle
                amountTitle="contractEasyLoanStepOne-firstSliderTitle"
                termTitle="contractEasyLoanStepOne-secondSliderTitle"
                getInstallment={getInstallment}
                getMinInstallment={requestMinInstallmentQuantity}
                immContractLoan={immContractEasyLoan}
                setLoanAmount={setLoanAmount}
                setLoanTerm={setLoanTerm}
                showTooltip={showTooltip}
                isMaxAmountError={maxAmountError}
                productType={LOANS_MORTGAGES_EASY_LOAN_TYPE_C}
            />
        );
    }
    
    onIncomeChange(income) {
        if (NUMBER_WITH_DECIMALS_REGEX.test(income) || (EMPTY_REGEX.test(income))) {
            const { immContractEasyLoan } = this.props;
            const immOutcome = immContractEasyLoan.get(OUTCOME);
            this.handleAccept(income, immOutcome.get(EXPENSES), immOutcome.get(RENTAL));
        }
    }

    onExpensesChange(expenses) {
        if (NUMBER_WITH_DECIMALS_REGEX.test(expenses) || (EMPTY_REGEX.test(expenses))) {
            const { immContractEasyLoan } = this.props;
            const immOutcome = immContractEasyLoan.get(OUTCOME);
            this.handleAccept(immOutcome.get(INCOME),  expenses, immOutcome.get(RENTAL));
        }
    }

    onRentalChange(rental) {
        if (NUMBER_WITH_DECIMALS_REGEX.test(rental) || (EMPTY_REGEX.test(rental))) {
            const { immContractEasyLoan } = this.props;
            const immOutcome = immContractEasyLoan.get(OUTCOME);
            this.handleAccept(immOutcome.get(INCOME),  immOutcome.get(EXPENSES), rental);
        }
    }

    handleAccept(income, expenses, rental) {
        const { onAccept } = this.props;

        onAccept({
            income,
            expenses,
            rental
        });
    }

    buildLaborSelect() {
        const {immContractEasyLoan} = this.props

        const immOutcome = immContractEasyLoan.get(OUTCOME);
        const income = immOutcome.get(INCOME);
        const expenses = immOutcome.get(EXPENSES);
        const rental = immOutcome.get(RENTAL);
        const newJobType = this.buildJobTypeField();
        const monthlyIncomeError = immContractEasyLoan.get("monthlyIncomeError");
        const employmentLevelList = immContractEasyLoan.get("employmentLevelList")
        const employmentLevel = immContractEasyLoan.get('newJobType') && employmentLevelList.size > 0 && this.buildEmploymentLevelField();
        const contractType = immContractEasyLoan.get('employmentLevel') && immContractEasyLoan.get('contractTypeList').size > 0 && this.buildContractTypeField();

        return (
            <div className="contract-easy-loan-type-c-step1__purpose-select">
                <div className="contract-easy-loan-type-c-step1__labor-title">
                    <FormattedText value="contractEasyLoanTypeC-labortitle" />
                </div>
                 
                <div className="contract-easy-loan-type-c-step1__purpose-select-title">
                    <FormattedText value="contractEasyLoanTypeC-income" />
                </div>
                <div className="contract-easy-loan-type-c-step1__form-wrap">
                    <div  className="contract-easy-loan-type-c-step1__input-wrap">
                        <div className="contract-easy-loan-type-c-step1__ok-input">
                            <AmountInput
                                amount={income}
                                textAlignRight
                                callback={this.onIncomeChange}
                                maxBackEndFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                                maxIntegerLength={MAX_LENGTH_NUMBER_INPUT}
                                hideFocusZero
                                fluid
                                language={getLanguage()}
                                error={monthlyIncomeError}
                                errorMsg={formatText('contractEasyLoanTypeC-incomeErrorMessage')}
                                handleOnFocus={recordEasyLoanCMonthlyIncome}                    
                            />
                        </div>
                        <span className="contract-easy-loan-type-c-step1__symbol">{EURO_SYMBOL}</span> 
                    </div>

                    <div className="contract-easy-loan-type-c-step1__purpose-select-title">
                        <FormattedText value="contractEasyLoanTypeC-expense" />
                    </div>
                    <div className="contract-easy-loan-type-c-step1__input-wrap">
                        <div className="contract-easy-loan-type-c-step1__ok-input">
                            <AmountInput
                                amount={expenses}
                                textAlignRight
                                callback={this.onExpensesChange}
                                maxBackEndFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                                maxIntegerLength={MAX_LENGTH_NUMBER_INPUT}
                                hideFocusZero
                                fluid
                                language={getLanguage()}
                                handleOnFocus={recordEasyLoanCMonthlyExpenses}
                            />
                        </div>
                        <span className="contract-easy-loan-type-c-step1__symbol">{EURO_SYMBOL}</span> 
                    </div>
                    <div className="contract-easy-loan-type-c-step1__purpose-select-title">
                        <FormattedText value="contractEasyLoanTypeC-rental" />
                    </div>
                    <div className="contract-easy-loan-type-c-step1__input-wrap">
                        <div className="contract-easy-loan-type-c-step1__ok-input">
                            <AmountInput
                                amount={rental}
                                textAlignRight
                                callback={this.onRentalChange}
                                maxBackEndFractionLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                                maxIntegerLength={MAX_LENGTH_NUMBER_INPUT}
                                hideFocusZero
                                fluid
                                language={getLanguage()}
                                handleOnFocus={recordEasyLoanCRentalExpenses}
                            /> 
                        </div>
                        <span className="contract-easy-loan-type-c-step1__symbol">{EURO_SYMBOL}</span> 
                    </div>
                </div>
                <div className="contract-easy-loan-type-c-step1__purpose-select-title">
                    <FormattedText value="contractEasyLoanTypeC-employment" />
                </div>
                <div className="contract-easy-loan-type-c-step1__input-employment">
                    {newJobType}
                    {employmentLevel}
                    {contractType}   
                </div>
            </div>

            
        );
    }
    //  *** Handlers ***

    handlePreContractInformationDownload() {
        recordEasyLoanCINEClick();
        this.props.downloadPreContractDocument();
    }

    handlePurposeSelectChange(purpose) {
        recordPurposeSelectChange();
        this.props.setPurpose({ purpose: purpose.value });
    }
    handleAgreeCheckModal(event) {
        recordEasyLoanCAuthorizationCheckbox(event.target.checked);
        this.props.toggleAgreeCheckbox()
    }
   

    buildCheckbox() {
        const {
            immContractEasyLoan,
        } = this.props;

        const errorMessage = formatText('contractEasyLoanStepThree-checkboxErrorMessage');
        const checkboxLabel = formatText('contractEasyLoanTypeC-checkboxlabel');
        const agreeCheckboxStep1 = immContractEasyLoan.get('agreeCheckboxStep1');

        const checkbox = (
            <div>
                <OKCheckbox
                    extraClass="contract-loan-pdf-viewer__checkbox"
                    disabled={false}
                    errorMessage={errorMessage}
                    idName="contract-loan-pdf-viewer-checkbox"
                    label={checkboxLabel}
                    onChange={this.handleAgreeCheckModal}
                    value={agreeCheckboxStep1}
                    />
            </div>
        ) 
        return checkbox ;
       
    }

    buildGenericSelect(params) {
        const {
            immContractEasyLoan,
        } = this.props;

        const label = formatText(params.label);
        const list = immContractEasyLoan.get(params.typeList);
        const listJS = list.size ? list.toJS() : list.toArray();
        const error = immContractEasyLoan.get('validate') && !params.value && this.buildError(params.errorMessage);
        return (
            <div className="contract-easy-loan-type-c-step1__laborView">
                <OKSelect
                    label={label}
                    name={params.name}
                    options={listJS}
                    searchable={false}
                    onChange={params.handleOnChangeEvent}
                    value={params.value}
                    errorState={!!error}
                    onFocusFunc={params.handleOnFocus}
                    onBlur={params.handleOnBlur}
                />
                <div className="col-xs-12">
                    {error}
                </div>
            </div>
        );
    }

    handleJobTypeChange(event) {
        const {
            formHandlers,
        } = this.props;

        recordEasyLoanCEmploymentStatus(event.value);
        formHandlers.handleJobTypeChange(event)
    }

    buildJobTypeField() {
        const {
            immContractEasyLoan,
        } = this.props;

        const params = {
            errorMessage: "contractEasyLoanTypeC-laboralStatusJobTypeError",
            handleOnChangeEvent: this.handleJobTypeChange,
            label: "contractEasyLoanTypeC-selectJobTypeplaceHolder",
            name: "newJobType-select",
            value: immContractEasyLoan.get('selectedJobType'),
            typeList: "newJobTypesList",
            handleOnFocus: recordEasyLoanCEmploymentStatusFocus,
            handleOnBlur: recordEasyLoanCEmploymentStatusBlur,
        };

        return this.buildGenericSelect(params);
    }

    buildError(value) {
        return (
            <FormattedText
                className="payroll-loan-request-step-one__error"
                value={value}
            />
        );
    }

    handleEmploymentLevelChange(event) {
        const { formHandlers } = this.props;
        recordEasyLoanCApprovedEmploymentLevel(event.value);
        formHandlers.handleEmploymentLevelChange(event);
    }

    buildEmploymentLevelField() {
        const {
            immContractEasyLoan,
        } = this.props;

        const params = {
            errorMessage: "contractEasyLoanTypeC-laboralStatusEmploymentLevelError",
            handleOnChangeEvent: this.handleEmploymentLevelChange,
            label: "contractEasyLoanTypeC-laboralStatusEmploymentLevel",
            name: "newJobType-select",
            value: immContractEasyLoan.get('employmentLevel'),
            typeList: "employmentLevelList",
            handleOnFocus: recordEasyLoanCApprovedEmploymentLevelOpen,
            handleOnBlur: recordEasyLoanCApprovedEmploymentLevelClose,
        };

        return this.buildGenericSelect(params);
    }

    handleContractTypeChange(event) {
        const { formHandlers } = this.props;
        recordEasyLoanTypeCContract(event.value);
        formHandlers.handleContractTypeChange(event);
    }

    buildContractTypeField() {
        const {
            immContractEasyLoan,
        } = this.props;

        const params = {
            errorMessage: "contractEasyLoanTypeC-laboralStatusContractTypeError",
            handleOnChangeEvent: this.handleContractTypeChange,
            label: "contractEasyLoanTypeC-laboralStatusContractType",
            name: "contractType-select",
            value: immContractEasyLoan.get('contractType'),
            typeList: "contractTypeList",
            handleOnFocus: recordEasyLoanTypeCContractOpen,
            handleOnBlur: recordEasyLoanTypeCContractClose,
        };

        return this.buildGenericSelect(params);
    }
    
    render() {
        const { immContractEasyLoan } = this.props;
        const header = this.buildHeader();
        const sliderSection = this.buildSliderSection();
        const purposeSelect = this.buildPurposeSelect();
        const laborSelect = this.buildLaborSelect();
        const checkbox = this.buildCheckbox()

        return (
            <section className="contract-easy-loan-type-c-step1">
                {header}
                {sliderSection}
                {purposeSelect}
                {laborSelect}
                <ContractEasyLoanStepOneWaffer immContractEasyLoan={immContractEasyLoan} />
                <div className="contract-easy-loan-type-c-step1__see-info text-right">
                    <OKButton
                        onClick={this.handlePreContractInformationDownload}
                        modifier="link-complementary"
                    >
                        <FormattedText value="contractEasyLoanStepOne-seeNormalizedEuropeanInformation" />
                    </OKButton>
                </div>
                {checkbox}
                <ContractLoanDueInformation title="gdprEasyLoan-title" message="gdprEasyLoan-message" />
            </section>
        );
    }
}

ContractEasyLoanTypeCStep1.propTypes = {
    downloadPreContractDocument: PropTypes.func.isRequired,
    getInstallment: PropTypes.func.isRequired,
    immContractEasyLoan: PropTypes.object.isRequired,
    immContractLoan:PropTypes.object.isRequired,
    formHandlers: PropTypes.object.isRequired,
    toggleAgreeCheckbox :PropTypes.func.isRequired,
    setLoanAmount: PropTypes.func.isRequired,
    setLoanTerm: PropTypes.func.isRequired,
    setPurpose: PropTypes.func.isRequired,
    requestMinInstallmentQuantity: PropTypes.func.isRequired,
    showTooltip: PropTypes.bool.isRequired,
    validate: PropTypes.bool.isRequired,
    onAccept: PropTypes.func.isRequired,
};

module.exports = ContractEasyLoanTypeCStep1;
